import Vue from 'vue'
import { MutationTree } from 'vuex'

import { Portion } from '@/models'

import { makeRelationalObject } from '../../models'
import { ItemPortions, MenuState } from '../state'

export const ADD_PORTION = 'ADD_PORTION'
export const ADD_ITEM_PORTIONS = 'ADD_ITEM_PORTIONS'
export const CLEAR_ITEM_PORTIONS = 'CLEAR_ITEM_PORTIONS'
export const INCREMENT_ITEM_PORTIONS_QUERY_INDEX = 'INCREMENT_ITEM_PORTIONS_QUERY_INDEX'
export const LOADED_ALL_ITEM_PORTIONS = 'LOADED_ALL_ITEM_PORTIONS'
export const REMOVE_ITEM_PORTIONS = 'REMOVE_ITEM_PORTIONS'
export const RESET_ITEM_PORTIONS_QUERY_INDEX = 'RESET_ITEM_PORTIONS_QUERY_INDEX'
export const RESET_LOADED_ALL_ITEM_PORTIONS = 'RESET_LOADED_ALL_ITEM_PORTIONS'
export const UPDATE_ITEM_PORTIONS = 'UPDATE_ITEM_PORTIONS'
export const UPDATE_ITEM_PORTIONS_TOTAL = 'UPDATE_ITEM_PORTIONS_TOTAL'
export const UPDATE_PORTIONS = 'UPDATE_PORTIONS'

const mutations: MutationTree<MenuState> = {
  [ADD_PORTION] (state, portion: Portion) {
    state.portions.elements.push(portion)
  },

  [ADD_ITEM_PORTIONS] (state, itemId: number) {
    const itemPortions: ItemPortions = {
      ...makeRelationalObject(),
      query: {}
    }

    Vue.set(state.items.portions, itemId, itemPortions)
  },

  [CLEAR_ITEM_PORTIONS] (state) {
    state.items.portions = {}
  },

  [INCREMENT_ITEM_PORTIONS_QUERY_INDEX] (
    state,
    { itemId, offset }: { itemId: number; offset: number }
  ) {
    const itemPortions = state.items.portions[itemId]

    if (itemPortions === undefined) {
      throw new Error(`Portions relation for Item "${itemId}" was not found`)
    }

    itemPortions.query.index = (itemPortions.query.index ?? 0) + offset
  },

  [LOADED_ALL_ITEM_PORTIONS] (state, itemId: number) {
    const itemPortions = state.items.portions[itemId]

    if (itemPortions === undefined) {
      throw new Error(`Portions relation for Item "${itemId}" was not found`)
    }

    itemPortions.didLoadAll = true
  },

  [REMOVE_ITEM_PORTIONS] (state, itemId: number) {
    Vue.delete(state.items.portions, itemId)
  },

  [RESET_ITEM_PORTIONS_QUERY_INDEX] (state, itemId: number) {
    const itemPortions = state.items.portions[itemId]

    if (itemPortions === undefined) {
      throw new Error(`Portions relation for Item "${itemId}" was not found`)
    }

    itemPortions.query.index = 0
  },

  [RESET_LOADED_ALL_ITEM_PORTIONS] (state, itemId: number) {
    const itemPortions = state.items.portions[itemId]

    if (itemPortions === undefined) {
      throw new Error(`Portions relation for Item "${itemId}" was not found`)
    }

    itemPortions.didLoadAll = false
  },

  [UPDATE_ITEM_PORTIONS] (
    state,
    { itemId, portions }: { itemId: number; portions: number[] }
  ) {
    const itemPortions = state.items.portions[itemId]

    if (itemPortions === undefined) {
      throw new Error(`Portions relation for Item "${itemId}" was not found`)
    }

    itemPortions.ids = new Set(portions)
  },

  [UPDATE_ITEM_PORTIONS_TOTAL] (
    state,
    { itemId, total }: { itemId: number; total: number }
  ) {
    const itemPortions = state.items.portions[itemId]

    if (itemPortions === undefined) {
      throw new Error(`Portions relation for Item "${itemId}" was not found`)
    }

    itemPortions.total = total
  },

  [UPDATE_PORTIONS] (state, portions: Portion[]) {
    state.portions.elements = portions
  }
}

export default mutations
